import { setVisits } from '../utils/initialize';

import { SET_VISITS } from '../constants';

const initialState = setVisits();

const visits = (state = initialState, action) => {
  switch (action.type) {
    case SET_VISITS:
      return action.payload.visits;
    default:
      return state;
  }
};

export default visits;



// WEBPACK FOOTER //
// ./src/reducers/visits.js